import { render } from "./CreationTaskStyle.vue?vue&type=template&id=06a240d9&scoped=true"
import script from "./CreationTaskStyle.vue?vue&type=script&lang=js"
export * from "./CreationTaskStyle.vue?vue&type=script&lang=js"

import "./CreationTaskStyle.vue?vue&type=style&index=0&id=06a240d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a240d9"]])

export default __exports__